import React, { Component } from 'react';
import Loading from 'components/Loading/Loading';
import PaymentForm from 'components/forms/PaymentForm';
import { browserHistory } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectStripe } from 'react-stripe-elements';
import { addStripeCard } from 'actions/stripeCardActions';
import { resumeMembership } from 'actions/userActions';

class NewCardForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      action: 'none'
    };
  }

  handleUpdate = () => {
    this.setState({ action: 'update' }, () => {
      this.props.stripe.createToken().then(response => {
        const { token } = response;
        if (token) {
          this.handleAddStripeCard(token);
        }
      });
    });
  }

  handleAddStripeCard = (token) => {
    const { user, addStripeCard: addStripeCardFn } = this.props;

    if (user && user.stripeCustomerId) {
      addStripeCardFn(user.stripeCustomerId, token.id, this.resumeMembership, false);
    }
  }

  resumeMembership = () => {
    const { user, resumeMembership: resumeMembershipFn } = this.props;

    if (user && user.stripeCustomerId) {
      resumeMembershipFn(user.stripeCustomerId, () => {
        browserHistory.replace('/schedule-lesson');
      });
    }
  }

  handleReactivate = () => {
    this.setState({ action: 'resume' }, () => {
      this.resumeMembership();
    });
  }

  render() {
    const { action } = this.state;
    const { error, resumeStatus, stripeCards } = this.props;

    const isAddingCard = stripeCards.edit_status === 'loading';
    const isResuming = resumeStatus === 'LOADING';

    return (
      <div className="NewCardForm mx-auto">
        <h5 className="mt-5 mb-3 new-card-form__subtitle">Add a new card</h5>
        <PaymentForm />
        <p className="my-3">
          By purchasing, I agree to the{' '}
          <a href="https://www.rypeapp.com/terms-of-use" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{' '}
          and{' '}
          <a
            href="https://www.rypeapp.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{' '}
          set forth by Rype, Inc.
        </p>
        {isAddingCard || (isResuming && action === 'update') ? (
          <Loading size="small" />
        ) : (
          <button
            type="button"
            className="btn btn-green btn-lg btn-cursor text-white w-100"
            disabled={isResuming}
            onClick={this.handleUpdate}
          >
            Update Card
          </button>
        )}

        <div className="d-flex align-items-center my-5">
          <div className="new-card-form__divider" />
          <h6 className="my-0 px-2 font-weight-normal">or</h6>
          <div className="new-card-form__divider" />
        </div>
        <h5 className="my-4 new-card-form__subtitle">Try billing again on existing card</h5>
        {isResuming && action === 'resume' ? (
          <Loading size="small" />
        ) : (
          <button
            type="button"
            className="btn btn-primary btn-lg btn-cursor text-white w-100"
            disabled={isAddingCard || isResuming}
            onClick={this.handleReactivate}
          >
            Reactivate
          </button>
        )}
        {resumeStatus === 'FAIL' && (
          <p className="my-2 text-danger">{error.message || 'Something went wrong.'}</p>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    stripeCards: state.stripeCards,
    resumeStatus: state.user.resumeStatus,
    error: state.user.error
  };
}

export default compose(
  injectStripe,
  connect(mapStateToProps, {
    addStripeCard,
    resumeMembership
  })
)(NewCardForm);



// WEBPACK FOOTER //
// ./src/pages/student/PaymentFailure/NewCardForm/index.js